import React from "react";
import { ServiceHero, SectionTitle } from "@/components/Bits";
import { RequestForm } from "@/components/RequestForm";
import { useLang } from "@/context/LanguageContext";
import { Home, Car, ShoppingCart, Briefcase, Sparkles } from "lucide-react";

const ICONS = [Home, Car, ShoppingCart, Briefcase];

export default function Conciergerie() {
  const { t } = useLang();
  const categories = t("svc.con.categories").map((c, i) => ({ icon: ICONS[i], title: c.t, items: c.items }));
  return (
    <div className="bg-ivory">
      <ServiceHero eyebrow={t("svc.con.eyebrow")} title={t("svc.con.title")} subtitle={t("svc.con.subtitle")}
        image="https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=1920&q=85" />
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20">
        <SectionTitle eyebrow={t("svc.con.cEyebrow")} title={t("svc.con.cTitle")} className="mb-12" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
          {categories.map((c) => (
            <div key={c.title} className="rounded-xl bg-white border border-black/5 p-7 card-hover" data-testid={`concierge-cat-${c.title}`}>
              <div className="flex items-center gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-navy/5 text-gold"><c.icon className="h-6 w-6" /></span>
                <h3 className="font-serif text-xl font-semibold text-navy">{c.title}</h3>
              </div>
              <ul className="mt-5 grid grid-cols-2 gap-2 text-sm text-slate-600">
                {c.items.map((i) => <li key={i} className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-gold" /> {i}</li>)}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-7 rounded-xl bg-navy text-white p-8 flex items-center gap-4">
          <Sparkles className="h-8 w-8 text-gold shrink-0" />
          <div>
            <h3 className="font-serif text-xl font-semibold">{t("svc.con.custTitle")}</h3>
            <p className="text-white/70 text-sm mt-1">{t("svc.con.custDesc")}</p>
          </div>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 pb-24">
        <SectionTitle center title={t("svc.con.formTitle")} className="mb-8" />
        <RequestForm type="conciergerie" testid="concierge-form" submitLabel={t("svc.con.submit")}
          fields={[
            { name: "category", label: t("svc.con.fCat"), placeholder: t("svc.con.fCatPh") },
            { name: "date", label: t("svc.con.fDate"), type: "date" },
            { name: "budget", label: t("svc.con.fBudget"), placeholder: t("svc.con.fBudgetPh") },
          ]} />
      </section>
    </div>
  );
}
